import { FiCheck, FiUsers } from 'react-icons/fi';

import { useTranslation } from 'react-i18next';

import {

  ENTERPRISE_FEATURES,

  PLAN_INCLUDED_FEATURES,

  PLAN_PRICE_USD_PER_SEAT,

  PLAN_TRIAL_DAYS,

} from '@/config/planFeatures';

import { ATTACHMENT_PLAN_FEATURE_KEY } from '@/utils/taskAttachments';



type Props = {

  seatCount?: number;

  planDaysLeft?: number | null;

  planState?: string;

  hasPaidSubscription?: boolean;

};



export default function PlanFeaturesCard({

  seatCount = 1,

  planDaysLeft,

  planState,

  hasPaidSubscription,

}: Props) {

  const { t } = useTranslation();

  const seats = Math.max(1, seatCount);

  const estimate = seats * PLAN_PRICE_USD_PER_SEAT;

  const onTrial = planState === 'trial_local' || planState === 'trialing_billing';



  return (

    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5">

      <div className="flex flex-wrap items-start justify-between gap-4 mb-4">

        <div className="min-w-0 flex-1">

          <h2 className="text-sm font-semibold text-slate-800">Per-user billing</h2>

          <p className="text-[12px] text-slate-500 mt-0.5 leading-relaxed">

            CoTaskr Plan is billed per active member — seats sync when people join or leave.
            Code and Ship bill only users who open those products (assigned automatically).
            {onTrial ? ` ${PLAN_TRIAL_DAYS}-day trial on all products.` : ''}

          </p>

        </div>

        <div className="rounded-xl border border-indigo-100 bg-indigo-50/60 px-4 py-3 text-center shrink-0">

          <p className="text-[10px] font-semibold uppercase tracking-wide text-indigo-700">Active seats</p>

          <p className="text-2xl font-extrabold text-slate-900 mt-0.5 flex items-center justify-center gap-1.5">

            <FiUsers className="h-5 w-5 text-indigo-600" />

            {seats}

          </p>

          <p className="text-[11px] text-slate-600 mt-1">

            ${PLAN_PRICE_USD_PER_SEAT}/seat · est. ${estimate}/mo

          </p>

          {onTrial && (

            <p className="text-[10px] font-semibold text-indigo-600 mt-1">

              {planDaysLeft != null ? `${planDaysLeft} days left in trial` : 'Trial active'}

            </p>

          )}

          {hasPaidSubscription && !onTrial && (

            <p className="text-[10px] font-semibold text-emerald-700 mt-1">Subscription active</p>

          )}

        </div>

      </div>



      <p className="text-[11px] font-semibold text-slate-500 uppercase tracking-wide mb-2">

        Included with CoTaskr Plan

      </p>

      <ul className="grid gap-1.5 sm:grid-cols-2 text-[12px] text-slate-700">

        {PLAN_INCLUDED_FEATURES.slice(1).map((text) => (

          <li key={text} className="flex items-start gap-2">

            <FiCheck className="text-emerald-600 shrink-0 mt-0.5" size={14} />

            <span>{text === 'ATTACHMENT_LIMIT' ? t(ATTACHMENT_PLAN_FEATURE_KEY) : text}</span>

          </li>

        ))}

      </ul>



      <div className="mt-4 pt-4 border-t border-slate-100">

        <p className="text-[11px] font-semibold text-slate-500 uppercase tracking-wide mb-2">

          Enterprise add-ons

        </p>

        <ul className="text-[11px] text-slate-600 space-y-1">

          {ENTERPRISE_FEATURES.map((text) => (

            <li key={text}>· {text}</li>

          ))}

        </ul>

      </div>

    </div>

  );

}

